/* Varme PDP v2 — quantity, gallery, accordions and the review browser.
   Static markup is already correct on first paint; this only adds behaviour.
   Money strings are pre-rendered by Liquid into data-totals, so nothing here
   has to guess the shop's currency format. */
(function () {
  var root = document.querySelector('.varme-pdp');
  if (!root) return;

  /* ---- quantity ---- */
  var qtyWrap = root.querySelector('[data-v-qtywrap]');
  if (qtyWrap) {
    var totals = (qtyWrap.getAttribute('data-totals') || '').split('|');
    var max = Math.max(1, totals.length);
    var num = root.querySelector('[data-v-qtynum]');
    var input = root.querySelector('[data-v-qtyinput]');
    var dec = root.querySelector('[data-v-qtydec]');
    var inc = root.querySelector('[data-v-qtyinc]');
    var totalEls = [].slice.call(root.querySelectorAll('[data-v-total]'));
    var q = 1;
    var paint = function () {
      if (num) num.textContent = q;
      if (input) input.value = q;
      var s = totals[q - 1] || totals[0] || '';
      totalEls.forEach(function (el) { el.innerHTML = s; });
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= max;
    };
    if (dec) dec.addEventListener('click', function () { if (q > 1) { q--; paint(); } });
    if (inc) inc.addEventListener('click', function () { if (q < max) { q++; paint(); } });
    paint();
  }

  /* ---- gallery ---- */
  var track = root.querySelector('[data-v-track]');
  if (track) {
    var thumbs = [].slice.call(root.querySelectorAll('[data-v-go]'));
    var counter = root.querySelector('[data-v-counter]');
    var total = thumbs.length;
    var i = 0;
    var show = function (k) {
      i = (k + total) % total;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      thumbs.forEach(function (b, x) {
        b.setAttribute('aria-pressed', x === i ? 'true' : 'false');
        b.style.borderColor = x === i ? 'var(--color-accent)' : 'transparent';
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
    };
    thumbs.forEach(function (b, x) { b.addEventListener('click', function () { show(x); }); });
    var p = root.querySelector('[data-v-prev]'), nx = root.querySelector('[data-v-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var d = e.changedTouches[0].clientX - x0;
      if (Math.abs(d) > 45) show(d < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });
  }

  /* ---- accordions ---- */
  [].forEach.call(root.querySelectorAll('[data-v-acc]'), function (btn) {
    var panel = btn.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-v-panel')) return;
    var chev = btn.querySelector('svg');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) panel.setAttribute('hidden', ''); else panel.removeAttribute('hidden');
      if (chev) chev.style.transform = 'rotate(' + (open ? 0 : 180) + 'deg)';
    });
  });

  /* ---- review browser ---- */
  var grid = root.querySelector('[data-v-reviewgrid]');
  if (!grid) return;
  var cards = [].slice.call(grid.querySelectorAll('[data-v-review]'));
  var PAGE = 12;
  var state = { sort: 'recent', tag: null, stars: null, page: 1 };
  var totalReviews = cards.length;

  var starBtns = [].slice.call(root.querySelectorAll('[data-v-stars]'));
  var tagBtns = [].slice.call(root.querySelectorAll('[data-v-tag]'));
  var sortBtns = [].slice.call(root.querySelectorAll('[data-v-sort]'));
  var label = root.querySelector('[data-v-filterlabel]');
  var moreWrap = root.querySelector('[data-v-morewrap]');
  var moreBtn = root.querySelector('[data-v-more]');
  var none = root.querySelector('[data-v-none]');

  var pill = function (btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.style.borderColor = on ? 'var(--color-text)' : 'var(--color-divider)';
    btn.style.background = on ? 'var(--color-text)' : 'transparent';
    btn.style.color = on ? 'var(--color-bg)' : 'var(--color-neutral-800)';
  };

  var render = function () {
    var list = cards.filter(function (c) {
      if (state.stars && +c.getAttribute('data-rating') !== state.stars) return false;
      if (state.tag && c.getAttribute('data-tags').split('|').indexOf(state.tag) < 0) return false;
      return true;
    });
    var s = state.sort;
    list.sort(function (a, b) {
      if (s === 'recent') return +b.getAttribute('data-ts') - +a.getAttribute('data-ts');
      if (s === 'highest') return +b.getAttribute('data-rating') - +a.getAttribute('data-rating');
      if (s === 'lowest') return +a.getAttribute('data-rating') - +b.getAttribute('data-rating');
      return +b.getAttribute('data-helpful') - +a.getAttribute('data-helpful');
    });
    var shown = list.slice(0, state.page * PAGE);
    cards.forEach(function (c) { c.hidden = true; });
    shown.forEach(function (c) { c.hidden = false; grid.appendChild(c); });

    if (label) {
      var bits = [];
      if (state.stars) bits.push(state.stars + ' star only');
      if (state.tag) bits.push('\u201c' + state.tag + '\u201d');
      label.textContent = bits.length
        ? 'Showing ' + shown.length + ' of ' + list.length + ' \u00b7 ' + bits.join(' \u00b7 ') + ' \u2014 tap again to clear'
        : 'Showing ' + shown.length + ' of ' + totalReviews + ' published reviews';
    }
    if (moreWrap) moreWrap.hidden = shown.length >= list.length;
    if (none) none.hidden = list.length !== 0;
    starBtns.forEach(function (b) {
      var on = state.stars === +b.getAttribute('data-v-stars');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var fill = b.querySelector('span > span');
      if (fill) fill.style.background = on ? 'var(--color-text)' : 'var(--color-accent)';
    });
    tagBtns.forEach(function (b) { pill(b, state.tag === b.getAttribute('data-v-tag')); });
    sortBtns.forEach(function (b) { pill(b, state.sort === b.getAttribute('data-v-sort')); });
  };

  starBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var v = +b.getAttribute('data-v-stars');
      state.stars = state.stars === v ? null : v; state.page = 1; render();
    });
  });
  tagBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-v-tag');
      state.tag = state.tag === v ? null : v; state.page = 1; render();
    });
  });
  sortBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.sort = b.getAttribute('data-v-sort'); state.page = 1; render(); });
  });
  if (moreBtn) moreBtn.addEventListener('click', function () { state.page += 1; render(); });
  render();
})();
